import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=0c17871c&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=0c17871c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17871c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c17871c')) {
      api.createRecord('0c17871c', component.options)
    } else {
      api.reload('0c17871c', component.options)
    }
    module.hot.accept("./DefaultLayout.vue?vue&type=template&id=0c17871c&scoped=true", function () {
      api.rerender('0c17871c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/DefaultLayout.vue"
export default component.exports